import { useMemoizedArray } from '@hooks/useMemoizedArray';
import Product from '@models/product';
import { ProductVariation, VariationGroup } from '@typings/product';
import React from 'react';

export const useProductVariations = (product: Product, variationGroups: Array<VariationGroup>) => {
  const variationGroupsArr = useMemoizedArray(variationGroups);
  return React.useMemo(() => {
    const activeValues = Object.fromEntries(
      variationGroupsArr.map((variationGroup) => [
        variationGroup,
        product.variationValues?.find(({ name }) => name === variationGroup)?.value,
      ]),
    );

    return variationGroupsArr.map((variationGroup) => {
      const active = activeValues[variationGroup];
      const values = product.variationAttributes?.find(({ id }) => id === variationGroup)?.values;
      const variations = values
        ?.map(({ value }) =>
          product.variations?.find((variation) =>
            variation.variationValues.every((variationValue) =>
              variationValue.name === variationGroup
                ? variationValue.value === value
                : variationValue.value === activeValues[variationValue.name],
            ),
          ),
        )
        .filter<ProductVariation>(Boolean as any);

      return {
        active,
        values,
        variations,
      };
    });
  }, [variationGroupsArr, product]);
};
